import React, { useState } from 'react';
import classes from '../../../assets/Global.module.css';
import Select from '../../../assets/essentials/Select';
import Button from '../../../assets/essentials/Button';
import PutBody from '../../../api/internal/PutBody';

type AssetAdminProps = {
  data: AssetAdmin;
  assetId: number;
  RefreshPage: Function;
};

function Admin({ data, assetId, RefreshPage }: AssetAdminProps) {
  const [isActive, setIsActive] = useState(data.isActive);

  const handleClick = () => {
    PutBody(`/Asset/UpdateAssetAdmin`, {
      assetId: assetId,
      isActive: isActive,
    }).then(response => {
      if (response) {
        RefreshPage('Admin', ['Audit']);
      }
    });
  };

  return (
    <>
      <div className={`${classes.attribute} ${classes.span3}`}>
        <label>Asset Status</label>
        <Select
          value={isActive ? 'true' : 'false'}
          onChange={e => setIsActive(e.target.value === 'true')}
        >
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </Select>
      </div>
      <div>
        <Button onClick={handleClick} variant="good">
          Submit
        </Button>
      </div>
    </>
  );
}

export default Admin;
